import React from 'react';
import { Helmet } from 'react-helmet';
import { SubTitle, BodyText } from '@minerva-analytics/pantheon';

import {
  AboutContent,
} from './About.styles';
import {
  LandingPageContainer as AboutContainer
} from '../LandingPage/LandingPage.styles';

const About = () => (
  <AboutContainer>
    <Helmet>
      <title>{`About Quickscope | Quickscope`}</title>
      <meta property="og:title" content="Quickscope's About Page" />
      <meta
        name="description"
        property="og:description"
        content="Quickscope is a video game newsletter built by life-long gamers for gamers. Revelant, trusted news. This is our mission."
      />
    </Helmet>
    <AboutContent>
      <h1> About Quickscope </h1>
      <SubTitle> Created by Gamers, for Gamers </SubTitle>
      <BodyText>
        It’s difficult to find relevant, unbiased, trusted news for gamers. As avid video gamers, we felt this problem over and over. That’s why we created Quickscope: to sift through the masses of irrelevant information and only provide you with the best news. We currently have a daily email newsletter with gaming deals, reviews, and news vetted by us.
      </BodyText>
      <SubTitle> Our Promise </SubTitle>
      <BodyText>
        At Quickscope, we want finding video game news to be as easy as reading a short email. That’s why we source news from the most trusted sources around the world. And share those stories with you.
      </BodyText>
      <SubTitle> Contact Us </SubTitle>
      <BodyText>
        We always want to hear what you’re thinking. Contact us any time by emailing <a href="mailto:help@thequickscope.com" target="_top">help@thequickscope.com</a>, calling <span>617-335-3742</span>, or reaching out on social media!
      </BodyText>
    </AboutContent>
  </AboutContainer>
);

export default About;